export const singlePaymentConstants = {
    IGNORE_SCHEDULED_AND_RECENT_PAYMENTS: 'IGNORE_SCHEDULED_AND_RECENT_PAYMENTS',
    SHOW_SCHEDULED_AND_RECENT_PAYMENTS: 'SHOW_SCHEDULED_AND_RECENT_PAYMENTS',
    SET_FORM_START_EVENT_EMITTED: 'SET_SINGLE_PAYMENT_FORM_START_EVENT_EMITTED',
    CLEAR_FORM_START_EVENT_EMITTED: 'CLEAR_SINGLE_PAYMENT_FORM_START_EVENT_EMITTED',
}